import { createReducer, on } from '@ngrx/store';
import { Quiz } from '../models';
import { quizActions } from '../actions/quizes.actions';

export interface QuizState {
    quizId: string | null;
    quiz: Quiz | null;
    loading: boolean;
    loaded: boolean | null;
}

const initialState: QuizState = {
    quizId: null,
    quiz: null,
    loading: false,
    loaded: null,
};

export const quizReducer = createReducer(
    initialState,

    // Get Quiz
    on(
        quizActions.getQuiz,
        (state, { id }): QuizState => ({
            ...initialState,
            quizId: id,
            loading: true,
        }),
    ),
    on(
        quizActions.getQuizSuccess,
        (state, { payload }): QuizState => ({
            ...state,
            quiz: payload,
            loading: false,
            loaded: true,
        }),
    ),
    on(
        quizActions.getQuizError,
        (state): QuizState => ({
            ...state,
            loading: false,
            loaded: false,
        }),
    ),

    // Clear
    on(quizActions.clear, (): QuizState => ({ ...initialState })),
);
